import React, { useState, useEffect } from "react";
import api from "../../Services/api";

const Beneficios = () => {

    const [planoA, setPlanoA] = useState<any>();
    const [planoB, setPlanoB] = useState<any>();
    const [planoTaesa, setPlanoTaesa] = useState<any>();
    const [planoTaesa2, setPlanoTaesa2] = useState<any>();
    const [tipos, setTipos] = useState<any>();
    const [tipoA, setTipoA] = useState<any>();
    const [tipoB, setTipoB] = useState<any>();
    const [tipoTaesa2, setTipoTaesa2] = useState<any>();
    let sumTaesa = 0;

    useEffect(() => {
        api
            .get("/ObterInformacoesPlano")
            .then((response) => {

                response.data.results.map((item: any) => {

                    if (item.NomePlano === "Plano A") {
                        //setPlanoA({ativoL:item.AtivoLiquido, ativo:item.Ativos, assistidos:item.Assistidos, pensionistas:item.Pensionistas, licenciados:item.Licenciados, autopatrocinados:item.Autopatrocinados, bpd:item.BPD, peculio:item.Peculio, anoValorPago:item.AnoValorPago, valorPago:item.ValorPago, pensao:item.Pensao, invalidez:item.Invalidez, prestacaoUnica:item.PrestacaoUnica, especial:item.Especial, tempoCont:item.TempoContribuicao});
                        setPlanoA([item.Pensao, item.Invalidez, item.Programados, item.AnoValorPago, item.ValorPago]); //programados
                    }

                    if (item.NomePlano === "Plano B") {
                        //setPlanoB({ ativoL: item.AtivoLiquido, ativo: item.Ativos, assistidos: item.Assistidos, pensionistas: item.Pensionistas, licenciados: item.Licenciados, autopatrocinados: item.Autopatrocinados, bpd: item.BPD, peculio: item.Peculio, anoValorPago: item.AnoValorPago, valorPago: item.ValorPago, pensao: item.Pensao, invalidez: item.Invalidez, prestacaoUnica: item.PrestacaoUnica, especial: item.Especial, tempoCont: item.TempoContribuicao });
                        setPlanoB([item.Pensao, item.Invalidez, item.ProgramadosAtuarial, item.ProgramadosFinanceiro, item.AnoValorPago, item.ValorPago]);
                    }

                    if (item.NomePlano === "Plano Taesa") {
                        //setPlanoB({ ativoL: item.AtivoLiquido, ativo: item.Ativos, assistidos: item.Assistidos, pensionistas: item.Pensionistas, licenciados: item.Licenciados, autopatrocinados: item.Autopatrocinados, bpd: item.BPD, peculio: item.Peculio, anoValorPago: item.AnoValorPago, valorPago: item.ValorPago, pensao: item.Pensao, invalidez: item.Invalidez, prestacaoUnica: item.PrestacaoUnica, especial: item.Especial, tempoCont: item.TempoContribuicao });
                        setPlanoTaesa([item.Ativos, item.Assistidos, item.Pensionistas, item.Autopatrocinados, item.BPD, item.AnoValorPago, item.ValorPago]);
                    }

                    if (item.NomePlano === "Plano Taesa") {
                        //setPlanoB({ ativoL: item.AtivoLiquido, ativo: item.Ativos, assistidos: item.Assistidos, pensionistas: item.Pensionistas, licenciados: item.Licenciados, autopatrocinados: item.Autopatrocinados, bpd: item.BPD, peculio: item.Peculio, anoValorPago: item.AnoValorPago, valorPago: item.ValorPago, pensao: item.Pensao, invalidez: item.Invalidez, prestacaoUnica: item.PrestacaoUnica, especial: item.Especial, tempoCont: item.TempoContribuicao });
                        setPlanoTaesa2([item.Pensao, item.Invalidez, item.ProgramadosFinanceiro, item.AnoValorPago, item.ValorPago]); //programados
                    }

                    return true;

                })
                setTipos(["Ativos ", "Assistidos", "Pensionistas", "Autopatrocinados", "BPD"]);
                setTipoA(["Pensão ", "Invalidez", "Programados"]);
                setTipoB(["Pensão ", "Invalidez", "Programados Atuarial", "Programados Financeiro"]);
                setTipoTaesa2(["Pensão ", "Invalidez", "Programados Financeiro"]);
            })
            .catch((err) => {
                throw new Error(err);
            });
    }, []);

    function getTotalTaesa() {
        tipos?.map((tipo: any, index: any) => { sumTaesa = sumTaesa + planoTaesa[index]; return true; });
        return sumTaesa;
    }
    return (

        <div className="page-numeros__beneficios">

            <h3> Benefícios pagos </h3>
            <div>

                <div >
                    <div>


                        {planoA &&
                            <>
                                <div className="line mb-4 mt-6">
                                    <p><strong>Plano A </strong> <br /> Valor pago em  {planoA[3]} : {planoA[4]?.toLocaleString('pt-BR')}  </p>
                                </div>
                                <div className="table">
                                    <table className="_table small">
                                        <tbody>
                                            <>

                                                {tipoA?.map((tipo: any, index: any) => (
                                                    <tr key={index}>
                                                        <td>{tipo}</td>
                                                        <td> {planoA[index]?.toLocaleString('pt-BR')}</td>

                                                    </tr>
                                                ))}
                                            </>

                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td> Total </td>
                                                <td> 100% </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div></>}
                        {planoB &&
                            <>
                                <div className="line mb-4 mt-6">
                                    <p><strong>Plano B </strong> <br /> Valor pago em  {planoB[4]} : {planoB[5]?.toLocaleString('pt-BR')}  </p>
                                </div>
                                <div className="table">
                                    <table className="_table small">
                                        <tbody>
                                            <>

                                                {tipoB?.map((tipo: any, index: any) => (
                                                    <tr key={index}>
                                                        <td>{tipo}</td>
                                                        <td> {planoB[index]?.toLocaleString('pt-BR')}</td>

                                                    </tr>
                                                ))}
                                            </>

                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td> Total </td>
                                                <td> 100% </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div></>}
                        {planoTaesa &&
                            <>
                                <div className="line mb-4 mt-6">
                                    <p><strong>Plano Taesaprev </strong> <br /> Valor pago em  {planoTaesa[5]} : {planoTaesa[6]?.toLocaleString('pt-BR')}  </p>
                                </div>


                                <div className="table">
                                    <table className="_table small">
                                        <tbody>
                                            <>
                                                {tipoTaesa2?.map((tipo: any, index: any) => (
                                                    <tr key={index}>
                                                        <td>{tipo}</td>
                                                        <td> {planoTaesa2[index]?.toLocaleString('pt-BR')}</td>

                                                    </tr>
                                                ))}
                                            </>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td> Total </td>
                                                <td> 100% </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <div className="line mb-4 mt-6">

                                </div>


                                <div className="table">
                                    <table className="_table small">
                                        <tbody>
                                            <>

                                                {tipos?.map((tipo: any, index: any) => (
                                                    <tr key={index}>
                                                        <td>{tipo}</td>
                                                        <td> {planoTaesa[index]?.toLocaleString('pt-BR')}</td>
                                                    </tr>
                                                ))}
                                            </>

                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td> Total </td>
                                                <td> {getTotalTaesa()} </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </>
                        }
                    </div>
                </div>

            </div>
        </div >
    );
};
export default Beneficios;

